module.exports = __webpack_public_path__ + "static/img/illu_en_01.11be54d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_en_01.png
// module id = GOF/
// module chunks = 1